var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main-container"},[_c('Head',{staticClass:"main-header"}),_vm._t("main"),(!_vm.noFoot)?_c('Foot',{staticClass:"main-footer"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }